export default {
  startshopping_supplier: {
    subtitle: "للموردين",

    title1: "ابدأ البيع في",
    title2: "3 خطوات بسيطة",

    desc:
      "انضم إلى MAHAL وابدأ في استلام الطلبات من المطاعم الموثوقة بسهولة.",

    step1_title: "التسجيل كمورد",
    step1_desc:
      "أنشئ حساب المورد الخاص بك وأكمل التحقق للبدء بسرعة.",
    step1_cta: "إنشاء حساب مورد",

    step2_title: "إضافة منتجاتك",
    step2_desc:
      "قم برفع المنتجات وإدارة الأسعار وجعل الكتالوج الخاص بك مرئيًا للمطاعم.",
    step2_cta: "إدارة المنتجات",

    step3_title: "استلام وتنفيذ الطلبات",
    step3_desc:
      "استقبل الطلبات من المطاعم، وقم بالتوصيل في الوقت المحدد، ونمِّ عملك.",
    step3_cta: "لوحة تحكم المورد",
  },
};